import { getRequest } from './common'

const URL_BASE = '/api/v1/console/'

export function getLoggedInUserIdentity() {
  return getRequest(`${URL_BASE}users/me/`)
}

let userIdentityCache: any = null
export function getLoggedInUserIdentityWithCache() {
  if (userIdentityCache) return Promise.resolve(userIdentityCache)
  return getLoggedInUserIdentity().then((data) => {
    userIdentityCache = data
    return data
  })
}
